import { Model as i } from "../../model.js";
import { VoucherRedeemMethod as e } from "./voucherEnums.js";
class r extends i {
  constructor(t) {
    super(), this.internalCode = t.internalCode, this.internalShortCode = t.internalShortCode, this.url = t.url, this.status = t.status, this.initialDate = t.initialDate, this.settings = t.settings, this.expirationDate = t.expirationDate, this.text = t.text, this.code = t.code, this.internalSharedShortCode = t.internalSharedShortCode, this.currentUses = t.currentUses, this.detailedStatus = t.detailedStatus, this.nextActivationTimestamp = t.nextActivationTimestamp;
  }
  getAccessPointId() {
    return this.url.searchParams.get("id");
  }
  /**
   * external_promo$$$$internalCode|internalShortCode
   */
  getRedeemCodes() {
    const t = [], s = this.settings.externalPromotionId ? `${this.settings.externalPromotionId}$$$$$` : "";
    return (this.settings.redeemMethod === e.QR_CODE || this.settings.redeemMethod === e.QR_AND_BAR_CODE) && t.push({
      code: `${s}${this.internalCode}`,
      type: e.QR_CODE
    }), (this.settings.redeemMethod === e.BAR_CODE || this.settings.redeemMethod === e.QR_AND_BAR_CODE) && t.push({
      code: `${s}${this.internalShortCode}`,
      type: e.BAR_CODE
    }), t;
  }
}
export {
  r as VoucherModel
};
//# sourceMappingURL=voucher.model.js.map
